import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import compLogo from './../../statics/premCheck/compLogo.png';
class simpleHeader extends Component {
    constructor(props) {
        super(props);
       
      }
    render(){
        return (
            <Container>
               <div className="checkHeader">
                <div className="compLogo">
                    <a href="#">
                        <img src={compLogo}/>
                    </a>
                </div>
                <p className="companyName">
                    Glasses Company
                </p>
               </div>
            </Container>
        );
    }

}

export default simpleHeader;
